// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './plugins/base'
// import './plugins/chartist'
// import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import '@/validation/common/index'
import VCurrencyField from 'v-currency-field'
import 'vue2-datepicker/index.css'
import Toasted from 'vue-toasted'
import VueSocialSharing from 'vue-social-sharing'
import '@/assets/sass/style.scss';

import * as filters from './filters' // global filters

Vue.use(VueSocialSharing);
Vue.use(Toasted, {
  duration: 3000,
  keepOnHover: true,
  type: 'success'
})

Vue.use(VCurrencyField, {
	locale: 'en-IN',
  autoDecimalMode: true,
  decimalLength: 0,
  defaultValue: null,
	min: null,
	max: null,
  valueAsInteger: false,
  allowNegative: true,
})
// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// import serviceContainer from './service-container'

Vue.config.productionTip = false

new Vue({
  // provide: serviceContainer,
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
